import Overview from './overview/Overview';
import Vessel from '../vessel/Vessel';
import { IVesselFormData } from '../../../../shared/sharedTypes';
import DynamicTab from '../../../../shared/components/tabs/DynamicTab';

interface IFleetProps {
	vessels: IVesselFormData[];
}

// Create empty FC coponent
const Fleet: React.FC<IFleetProps> = ({ ...props }) => {
	return (
		<DynamicTab
			dynamicItem={Vessel} 
			dynamicItemProps={(item) => ({
				data:item,
				giveSpace:false,
				hideTab:true,
				isFleet: true,
			})}
			dynamicItemData={props.vessels}
			staticItems={[<Overview vessels={props.vessels} />]}
			tabColor="msi-chart-midgreen"
			giveSpace
		/>
	);
};

export default Fleet;
